export type CategoryDisplayIcon = {
  mediaIcon: ComputedRef<string>;
  displayType: ComputedRef<
    | 'default'
    | 'center_circle'
    | 'dimensionTest_and_result'
    | 'sponsor'
    | 'shortcuts'
    | 'additional'
  >;
};

export const useCategoryAncestorsDisplayIcon = (
  pAncestors: CategorySchema[] | Ref<CategorySchema[]>
): CategoryDisplayIcon => {
  const mediaIcon = computed(() => {
    const cat = toValue(pAncestors).find(
      (cat) =>
        cat.mediaIcon && cat.contentType !== ContentTypes.InterDisciplineFocusOn
    );
    return cat?.mediaIcon ?? null;
  });

  const displayType = computed<
    | 'default'
    | 'center_circle'
    | 'dimensionTest_and_result'
    | 'sponsor'
    | 'shortcuts'
    | 'additional'
    | null
  >(
    ():
      | 'default'
      | 'center_circle'
      | 'dimensionTest_and_result'
      | 'sponsor'
      | 'shortcuts'
      | 'additional'
      | null => {
      return toValue(pAncestors).reduce<
        | 'default'
        | 'center_circle'
        | 'dimensionTest_and_result'
        | 'sponsor'
        | 'shortcuts'
        | 'additional'
        | null
      >((acc, curr) => {
        if (!acc || acc !== 'center_circle') {
          acc = curr.displayType;
        }
        return acc;
      }, null);
    }
  );

  return {
    mediaIcon,
    displayType,
  };
};
